import { EnrichmentPlugin, Event } from '@amplitude/analytics-types'
import { getEnv } from '@unni/platform'

import {
  getBrowserInfo,
  getDeviceType,
  getPageDomain,
  getPageType,
  getPathSegments,
  getPathWithoutLocale,
  getPlatformDetail,
  getPlatformType,
  getReferringDomain,
  isMobile,
} from './browser-plugin-helpers'

import { countryToLocale, getCountryFromUrl } from '../language'

import type { BrowserProperties } from './browser-plugin.types'

class BrowserPlugin implements EnrichmentPlugin {
  name = 'browser-log-plugin'
  type = 'enrichment' as const

  async setup(): Promise<void> {
    return undefined
  }

  async execute(event: Event): Promise<Event | null> {
    const country = getCountryFromUrl(location.pathname)
    const browserInfo = getBrowserInfo()

    const browserProperties: BrowserProperties = {
      // Existing properties
      referrer: document.referrer,
      referring_domain: getReferringDomain(),
      domain: location.hostname,
      location: location.href,
      path: location.pathname,
      url: location.href,
      country,
      locale: countryToLocale(country),

      // Platform
      platform_type: getPlatformType(),
      platform_detail: getPlatformDetail(),

      // Page
      page_domain: getPageDomain(location.pathname),
      page_type: getPageType(location.pathname),
      path_without_locale: getPathWithoutLocale(location.pathname),
      path_segments: getPathSegments(location.pathname),

      // Device
      device_type: getDeviceType(),
      is_mobile: isMobile(),

      // Browser & OS
      browser_name: browserInfo.browser_name,
      browser_version: browserInfo.browser_version,
      os_name: browserInfo.os_name,
      os_version: browserInfo.os_version,

      // Optional: Full UA for debugging (only in dev/test)
      ...(getEnv('NEXT_PUBLIC_ENV') !== 'prod' && {
        user_agent_full: navigator.userAgent,
      }),
    }

    event.event_properties = {
      ...browserProperties,
      ...event.event_properties,
    }

    return event
  }
}

export default BrowserPlugin
